export { DMS_MODULE } from '../constants';
export const NAME = 'UzaverkaSkladu';
export const API_NAME = 'UzavSklad';
export const CRUMB_LABEL_KEY = 'UzaverkaSklad';
